import { createContext } from "react";

export interface PortalHostContextValue {
	tenantId: string;
}

const PortalHostContext = createContext<PortalHostContextValue | null>(null);

export default PortalHostContext;
